import { Campaign } from "./campaign"
import { CampaignReport } from "./campaign_report"
import { RemindCampaign } from "./remind_campaign"

export class Reminder {
    constructor(reminder) {
        this.campaign        = new Campaign(reminder);
        this.campaign_report = new CampaignReport(reminder.campaign_report);
        this.remind_campaign = new RemindCampaign(reminder.remind_campaign);
    }
}